'use client';

import { Image, Text } from '@doist/marketist';
import { DialogDisclosure, DialogProvider } from '@ariakit/react';
import { Modal } from 'components/modal/modal';
import { Markup } from '../markup/markup';
import css from './image.module.css';
export { Image };
export type ZoomableImageProps = {
  src: string;
  width: number;
  height: number;
  alt?: string;
  caption?: string;
  captionBlockedElements?: string[];
};
export function ZoomableImage({
  src,
  width,
  height,
  alt = '',
  caption,
  captionBlockedElements
}: ZoomableImageProps) {
  return <DialogProvider defaultOpen={false} data-sentry-element="DialogProvider" data-sentry-component="ZoomableImage" data-sentry-source-file="image.tsx">
            <figure>
                <DialogDisclosure data-sentry-element="DialogDisclosure" data-sentry-source-file="image.tsx">
                    <Image src={src} width={width} height={height} alt={alt} data-sentry-element="Image" data-sentry-source-file="image.tsx" />
                </DialogDisclosure>
                {caption ? <Text tag="figcaption" size="body-sm" className={css.figcaption}>
                        <Markup tagName="p" content={caption} blockList={captionBlockedElements} />
                    </Text> : null}
            </figure>

            <Modal data-sentry-element="Modal" data-sentry-source-file="image.tsx">
                <Image className={css.modalImage} src={src} alt={alt} width={width * 1.5} height={height * 1.5} data-sentry-element="Image" data-sentry-source-file="image.tsx" />
            </Modal>
        </DialogProvider>;
}